if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', class BundleBuilder extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.render();
      }

      getSelectedBundle(products){
        const variantKeys = Object.keys(variantsBundle);
        const key = variantKeys.find((key) => {
          return products.every((productId) => {
            for (const variant of variantsBundle[key]['bundle_variants']) {
              if (variant.id == productId) {
                return true;
              }
            }
            return false;
          });
        });
        return {id: key, ...variantsBundle[key]};
      }
  
      addBundleToCart(products) {
        let formData = { items: [] };

        let bundle = this.getSelectedBundle(products);

        formData.items.push({
          id: bundle.id,
          quantity: 1,
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((data) => {
            window.location.href = '/cart';
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }
  
      enableAddToCartButton() {
        let enableButton = false;
        this.querySelectorAll('.step-product input').forEach((stepProduct) => {
          if (!stepProduct.value) {
            enableButton = true;
            return;
          }
        });
        this.querySelector('button.add-to-cart-button').disabled = enableButton;

        let bundlePrice = this.querySelector('bundle-summary .bundle-price');

        if(!enableButton){
          let inputs = this.querySelectorAll('bundle-summary input'), products = [];

          inputs.forEach((input) => {
            products.push(input.value)
          });

          let bundle = this.getSelectedBundle(products);
          let percentage = parseFloat(bundle.bundle_data.bundle_price_adjusment);
          let currentPrice = bundle.bundle_data.price - (bundle.bundle_data.price * percentage / 100);
          let currentCompareAtPrice = this.dataset.priceFormat.replace('0.00', parseFloat(bundle.bundle_data.price / 100));
          currentPrice = this.dataset.priceFormat.replace('0.00', parseFloat(currentPrice / 100).toFixed(2));

          bundlePrice.querySelector('.compared-at-price').innerHTML = currentCompareAtPrice;
          bundlePrice.querySelector('.price').innerHTML = currentPrice;
          bundlePrice.classList.remove('hidden');
          this.querySelector('button.add-to-cart-button').classList.remove('hidden');
        }else{
          bundlePrice.classList.remove('hidden');
          this.querySelector('button.add-to-cart-button').classList.add('hidden');
          bundlePrice.querySelector('.compared-at-price').innerHTML = '';
          bundlePrice.querySelector('.price').innerHTML = '';
        }
      }
  
      render() {
        let templates = {
          title: `<h2>[[title]]</h2>`,
          productOption: `
            <product-option-card data-id="[[id]]" data-title="[[title]]" data-image="[[image]]" data-price="[[price]]" data-raw-price="[[raw-price]]">
              <div class="product-option-card">
                <div class="product-image">
                  <picture class="image">
                    <source type="image/webp" srcset="[[image]]" sizes="167px">
                    <img width="167" height="167" alt="[[title]]" src="[[image]]" loading="lazy" sizes="167px" decoding="async">
                  </picture>
                </div>
                <div class="product-info">
                  <p>[[title]]</p>
                  <div class="product-price">
                    <p><span class="compared-at-price" style="display: [[compared-at-price-display]];">[[compared-at-price]]</span>  <span class="price">[[price]]</span></p>
                    <div class="yotpo bottomLine" data-product-id="[[parent-product-id]]"></div>
                  </div>
                  <button type="button" class="product-option-button">Select</button>
                </div>
              </div>
            </product-option-card>
          `,
          bundleSummaryStepProduct: `
            <div class="step-product step-[[index]]">
              <div class="step-image">
                <input type="hidden" name="step">
                <div class="image-placeholder step-[[step]]"></div>
                <img class="hidden background-product-variant" alt="step-[[step]]">
              </div>
              <div class="info">
                <div class="product-info">
                  <p class="title">ADD ANOTHER PRODUCT FOR THE BUNDLE DISCOUNT</p>
                  <button type="button" class="control-button" data-step="[[step]]" data-action="add">Select</button>
                </div>
                <p class="price"></p>
              </div>
            </div>
          `,
        };
  
        let renderHTML = '';
        let stepTitles = this.dataset.stepTitles.split(',');
        for (let i = 0; i < variantsBundleSteps.length; i++) {
          renderHTML += templates.title.replaceAll('[[title]]', `Step ${i + 1} - ${stepTitles[i]}`);

          renderHTML += `<step-products data-step="${i}">
            <div class="swiper slider-builder">
              <div class="swiper-wrapper">`;
          for (let j = 0; j < variantsBundleSteps[i].length; j++) {
            const element = variantsBundleSteps[i][j];
            if (!element.featured_image) {
              element.featured_image =
                'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';
            }
  
            let currentCompareAtPrice = this.dataset.priceFormat.replace('0.00', parseFloat(element.compare_at_price / 100));
            let currentPrice = this.dataset.priceFormat.replace('0.00', parseFloat(element.price / 100).toFixed(2));

            renderHTML += `<div class="swiper-slide">` + templates.productOption
              .replaceAll('[[title]]', element.name)
              .replaceAll('[[image]]', element.featured_image)
              .replaceAll('[[id]]', element.id)
              .replaceAll('[[raw-price]]', element.price)
              .replaceAll('[[compared-at-price]]', currentCompareAtPrice)
              .replaceAll('[[compared-at-price-display]]', element.compare_at_price > 0 ? 'block' : 'none')
              .replaceAll('[[parent-product-id]]', element.parent_product_id)
              .replaceAll('[[price]]', currentPrice) + `</div>`;
          }
          renderHTML += `</div>
     
                <div class="swiper-button-container" style="position: relative;">
                        <div class="swiper-button-prev arrow-prev-customer"><svg viewBox="0 0 24 24" focusable="false" class="chakra-icon css-n5gr1q" aria-hidden="true"><path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></div>
                        <div class="swiper-pagination"></div>
                        <div class="swiper-button-next arrow-next-customer"><svg viewBox="0 0 24 24" focusable="false" class="chakra-icon css-n5gr1q" aria-hidden="true"><path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></div>
                    </div> 
          </div>
          </step-products>`;
        }
  
        renderHTML += `
          <bundle-summary>
            <div class="container">
              <div class="top-control">
                <div class="highlights">
                  <h4 class="bundle-count"><span class="count">0</span> ITEMS IN YOUR Beauty Bundle</h4>
                  <div class="message">Let's build your bundle!</div>
                </div>
                <button class="edit-button">Edit</button>
              </div>
              <div class="steps">`;
  
        for (let i = 0; i < variantsBundleSteps.length; i++) {
          renderHTML += templates.bundleSummaryStepProduct
            .replaceAll('[[step]]', i + 1)
            .replaceAll('[[index]]', i);
        }
  
        renderHTML += `
              </div>
              <div class="bundle-price hidden">
                <p><span class="compared-at-price"></span>  <span class="price"></span></p>
              </div>
              <button type="button" class="add-to-cart-button hidden" disabled>Add to Cart</button>
            </div>
          </bundle-summary>`;
  
        this.innerHTML = renderHTML;
      }
    });
  }
  
  if (!customElements.get('step-products')) {
    customElements.define('step-products', class StepProducts extends HTMLElement {
      constructor() {
        super();
        this.step = this.dataset.step;
      }
  
      connectedCallback() {
        // Initialize Swiper for this step-products element
        this.swiper = new Swiper(this.querySelector('.swiper'), {
            slidesPerView: "auto",
            spaceBetween: 16,
            slidesPerGroup: 1,
            centeredSlides: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: `.swiper-pagination`,
                type: 'progressbar',
            },
          });
      }
  
      reset() {
        this.bundleSummary = this.closest('bundle-builder').querySelector('bundle-summary');
        this.querySelectorAll('.product-option-button').forEach((button) => {
          button.classList.remove('selected');
          button.textContent = 'Select';
        });
  
        this.bundleSummary.clearStep(this.step);
      }
  
      submitStep(product) {
        this.bundleSummary = this.closest('bundle-builder').querySelector('bundle-summary');
        this.bundleSummary.updateStep(this.step, product);
      }
    });
  }

if (!customElements.get('product-option-card')) {
    customElements.define('product-option-card', class ProductOptionCard extends HTMLElement {
        constructor() {
            super();
            
            this.StepProducts = this.closest('step-products');
            this.product = {
                id: this.dataset.id,
                title: this.dataset.title,
                rawPrice: this.dataset.rawPrice,
                price: this.dataset.price,
                image: this.dataset.image
            }
        }

        connectedCallback() {
            this.querySelectorAll('.product-option-button').forEach((button) => {
                button.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    if(button.classList.contains('selected')){
                        this.StepProducts.reset();
                    }else{
                        this.StepProducts.reset();
                        button.classList.add('selected');
                        button.textContent = 'Remove';
                        this.StepProducts.submitStep(this.product);
                    }
                });
            });
        }
    });
}

if (!customElements.get('bundle-summary')) {
    customElements.define('bundle-summary', class BundleSummary extends HTMLElement {
        constructor() {
            super();

            this.bundleBuilder = this.closest('bundle-builder');
            this.inputs = this.querySelectorAll('input');
            this.editButton = this.querySelector('button.edit-button');
            this.controlButtonAll = this.querySelectorAll('button.control-button');
            this.addToCartButton = this.querySelector('button.add-to-cart-button');
            this.countSpan = this.querySelector('.count');
            this.stepHighlightMessages = this.bundleBuilder.dataset.stepHighlightMessages.split('|');
        }

        connectedCallback() {
            this.editButton.addEventListener('click', (evt) => {
                evt.preventDefault();
                if(this.editButton.classList.contains('close')){
                    this.editButton.classList.remove('close');
                    this.classList.remove('edit-mode');
                    this.editButton.textContent = 'Edit';
                }else{
                    this.editButton.classList.add('close');
                    this.classList.add('edit-mode');
                    this.editButton.textContent = 'Close';
                }
            });

            this.controlButtonAll.forEach((button) => {
                button.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    if(button.dataset.action === 'add') {
                        this.editButton.dispatchEvent(new MouseEvent('click', {bubbles: true, view: window}));
                        this.bundleBuilder.querySelector(`step-products[data-step="${button.dataset.step - 1}"]`).scrollIntoView( { behavior: 'smooth' });
                    } else {
                        this.bundleBuilder.querySelector(`step-products[data-step="${button.dataset.step - 1}"]`).reset();
                    }
                });
            });

            this.addToCartButton.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.addToCartButton.disabled = true;
                this.addToCart();
            });
        }

        addToCart(){
            let handleRequest = true, products = [];
            this.inputs.forEach((input) => {
                if(!input.value){
                    handleRequest = false
                }

                products.push(input.value)
            });

            if(handleRequest){
                this.bundleBuilder.addBundleToCart(products);
            }
        }

        updateStep(step, product){
            let stepProduct = this.querySelector('.step-product.step-' + step);
            stepProduct.classList.add('active');
            stepProduct.querySelector('input').value = product.id;
            stepProduct.querySelector('.image-placeholder').classList.add('hidden');
            stepProduct.querySelector('img').src = product.image;
            stepProduct.querySelector('img').classList.remove('hidden');
            stepProduct.querySelector('.title').textContent = product.title;
            stepProduct.querySelector('.price').innerHTML = product.price;
            this.bundleBuilder.enableAddToCartButton();

            let count = this.querySelectorAll('.image-placeholder.hidden').length
            this.countSpan.textContent = count;
            this.querySelector('.message').textContent = this.stepHighlightMessages[count];

            stepProduct.querySelector('.control-button').dataset.action = 'remove';
            stepProduct.querySelector('.control-button').textContent = 'Remove';
        }

        clearStep(step) {
            let stepProduct = this.querySelector('.step-product.step-' + step);
            stepProduct.classList.add('active');
            stepProduct.querySelector('input').value = '';
            stepProduct.querySelector('img').classList.add('hidden');
            stepProduct.querySelector('.image-placeholder').classList.remove('hidden');
            stepProduct.querySelector('.title').textContent = 'ADD ANOTHER PRODUCT FOR THE BUNDLE DISCOUNT';
            stepProduct.querySelector('.price').innerHTML = '';
            this.bundleBuilder.enableAddToCartButton();

            let count = this.querySelectorAll('.image-placeholder.hidden').length
            this.countSpan.textContent = count;
            this.querySelector('.message').textContent = this.stepHighlightMessages[count];

            stepProduct.querySelector('.control-button').dataset.action = 'add';
            stepProduct.querySelector('.control-button').textContent = 'Select';
        }
    });
}